import React, { ReactNode, Suspense } from "react";
import { Navigate } from "react-router-dom";

import LoadingSpinner from "../Icons/LoadingSpinner";

// Feedback 
const FeedbackEmployee = React.lazy(() => import("../pages/feedback/page"));
const CustomerFeedbackListPage = React.lazy(() => import('../pages/feedback/customer-list'));

//Project-Tracker
const Projects = React.lazy(() => import('../pages/Dashboard/Projects/projects/list'));
const Sprints = React.lazy(() => import('../pages/Dashboard/Projects/Sprints'));
const TicketList = React.lazy(() => import('../pages/Dashboard/Projects/Tickets/list'));
const AddTicket = React.lazy(() => import('../pages/Dashboard/Projects/Tickets/add'));

const ProtectedAdminManagerRoute: React.FC<{ children: ReactNode | any }> = ({
    children,
  }) => {
    const isManager = localStorage.getItem('isManager')
    const isAdmin=localStorage.getItem('roleName')
    return isManager === 'true'||isAdmin==="Admin" ? children : <Navigate to="/dashboard" />;
  };

  const renderProtectedRoute = (Component: React.ComponentType) => (
    <Suspense fallback={<LoadingSpinner className="mr-2 h-full w-14 animate-spin" />}>
      <ProtectedAdminManagerRoute>
        <Component />
      </ProtectedAdminManagerRoute>
    </Suspense>
  );
  
  export const AdminManagerRoutes = [
    {
      path: "/dashboard/projects",
      element: renderProtectedRoute(Projects),
      title: "Dashboard",
      role: ['admin', 'Manager'],
    },
    {
      path: "/dashboard/projects/:projectId/sprints/",
      element: renderProtectedRoute(Sprints),
      title: "Dashboard",
      role: ['admin'],
    },
    {
      path: "/dashboard/projects/:projectId/sprints/:sprintId/tickets",
      element: renderProtectedRoute(TicketList),
      title: "Dashboard",
      role: ['admin'],
    },
    {
      path: "/dashboard/projects/:projectId/tickets",
      element: renderProtectedRoute(TicketList),
      title: "Dashboard",
      role: ['admin'],
    },
    {
      path: "/dashboard/projects/:projectId/sprints/:sprintId/tickets/add-new",
      element: renderProtectedRoute(AddTicket),
      title: "Dashboard",
      role: ['admin'],
    },
    {
      path: "/dashboard/projects/:projectId/tickets/add-new",
      element: renderProtectedRoute(AddTicket),
      title: "Dashboard",
      role: ['admin'],
    },
    {
      path: "/dashboard/feedback/add",
      element: renderProtectedRoute(FeedbackEmployee),
      title: "Calendar",
      role: ['admin', 'Manager'],
    },
   
    {
      path: "/dashboard/feedback/customer-list",
      element: renderProtectedRoute(CustomerFeedbackListPage),
      title: "Calendar",
      role: ['admin', 'Manager'],
    },
  ];